import { PropsWithChildren } from 'react'
import styled from 'styled-components'

interface IMusicIconProps {
  paused: boolean
}

const StyledSvg = styled.svg`
  & {
    --accent: ${props => props.theme.colors.accent};
    --accent1: ${props => props.theme.colors.accent1};
    --supplementary1: ${props => props.theme.colors.supplementary1};
    --primary: ${props => props.theme.colors.primary};
  }
`

export const MusicIcon = ({ paused = true }: IMusicIconProps) => {
  return (
    <StyledSvg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="11.5" fill="var(--supplementary1)" stroke="var(--accent)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0869 11.4441C23.2741 11.0484 24.5 11.932 24.5 13.1834V21.3335C24.5 22.7142 23.3807 23.8335 22 23.8335C20.6193 23.8335 19.5 22.7142 19.5 21.3335C19.5 19.9528 20.6193 18.8335 22 18.8335C22.5628 18.8335 23.0822 19.0194 23.5 19.3333V16.5167C23.5 15.9479 22.9428 15.5463 22.4031 15.7261L17.9815 17.2C17.0968 17.4949 16.5 18.3229 16.5 19.2555V22.6668C16.5 24.0475 15.3807 25.1668 14 25.1668C12.6193 25.1668 11.5 24.0475 11.5 22.6668C11.5 21.2861 12.6193 20.1668 14 20.1668C14.5628 20.1668 15.0822 20.3528 15.5 20.6666V15.9222C15.5 14.5591 16.3722 13.349 17.6653 12.918L22.0869 11.4441Z"
        fill="var(--accent1)"
      />
      <circle cx="33" cy="32" r="7.5" fill="var(--supplementary1)" stroke="var(--primary)" />
      <path
        opacity={paused ? 1 : 0}
        d="M34.8598 33.595L32.6952 34.9178C31.3625 35.7322 29.6523 34.7731 29.6523 33.2112V31.8885V30.5657C29.6523 29.0038 31.3625 28.0447 32.6952 28.8591L34.8598 30.1819C36.1359 30.9618 36.1359 32.8152 34.8598 33.595Z"
        fill="var(--primary)"
      />
      <g opacity={paused ? 0 : 1}>
        <path
          d="M34 30C34 29.4477 34.4477 29 35 29C35.5523 29 36 29.4477 36 30V34C36 34.5523 35.5523 35 35 35C34.4477 35 34 34.5523 34 34V30Z"
          fill="var(--primary)"
        />
        <path
          d="M30 30C30 29.4477 30.4477 29 31 29C31.5523 29 32 29.4477 32 30V34C32 34.5523 31.5523 35 31 35C30.4477 35 30 34.5523 30 34V30Z"
          fill="var(--primary)"
        />
      </g>
    </StyledSvg>
  )
}
